import axios from "axios";
import { cmsHeaders } from "../exports/exports";

export const fetchcontactHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/contact-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchcontactFormHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/contact-form-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};
